var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b-section-title",class:{
    'b-section-title--important': _vm.important,
    'b-section-title--large': _vm.large,
    'b-section-title--mobile': _vm.$voicer.isMobile,
  }},[_c('div',{staticClass:"b-section-title__wrapper",class:{ 'mt-2': _vm.$voicer.isDesktopOrTablet, 'mt-4': _vm.$voicer.isMobile }},[_c('div',{staticClass:"b-section-title__message text-alternate body-2 font-weight-medium grey--text text--lighten-1"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"borderlines"},[_c('b-borderline',{attrs:{"color":_vm.color,"height":"4px"}})],1)],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }